<template>  
  <div>
    <v-autocomplete 
      item-text="display" 
      :error-messages="emsg" 
      @keyup.enter="save" 
      @input="onSelect(eitem.name);" 
      :label="eitem.header" 
      v-model="editedItem[eitem.name]" 
      :items="eitem.listItems" 
      :multiple="eitem.multiple || false"
      :search-input.sync="asearch[eitem.name]"
      placeholder="Start typing to Search"
    >
    </v-autocomplete>
  </div>
</template>

<script>
import utils from '../helpers/utils'
import { sync } from 'vuex-pathify'
export default {
  props: ['eitem', 'editedItem', 'asearch', 'onSelect', 'onInput', 'save', 'emsg'],
  methods: {
    
  }
}
</script>